import { Component, DestroyRef, inject, OnInit, ViewChild } from "@angular/core";
import { SwalComponent, SwalPortalTargets } from "@sweetalert2/ngx-sweetalert2";
import packageJson from '../../../../package.json';
import { DatabaseService } from "src/app/servicios/database/database.service";
import { CdkCopyToClipboard } from "@angular/cdk/clipboard";
import { UpdateService } from "src/app/servicios/update/update.service";
import { FsessionService } from "src/app/servicios/session/fsession.service";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { MatPaginator } from "@angular/material/paginator";
import { LoaderService } from "src/app/component/loader-spinner/loader.service";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ListenDOMChange } from "src/app/servicios/listen-DOM-change/listen-DOM-change.service";

@Component({
    selector: "app-acerca-de",
    templateUrl: "./acerca-de.component.html",
    styleUrls: ["./acerca-de.component.scss"],
    providers: [
        CdkCopyToClipboard,
        LoaderService,
    ],
    standalone: false
})
export class AcercaDeComponent implements OnInit {
  readonly swalTargets = inject(SwalPortalTargets);
  private db = inject(DatabaseService);
  private clipboard = inject(CdkCopyToClipboard);
  private updateService = inject(UpdateService);
  private fse = inject(FsessionService);
  private loaderService = inject(LoaderService);
  private _listenDOMChange = inject(ListenDOMChange);

  @ViewChild("aboutSwal") aboutSwal: SwalComponent;
  @ViewChild("versionsListSwal") versionsListSwal: SwalComponent;
  @ViewChild("changesSwal") changesSwal: SwalComponent;
  @ViewChild("terminos") terminos: SwalComponent;

  @ViewChild("releasePaginator", { static: true }) releasePaginator: MatPaginator;

  fileUrl =
    "https://gobernanza.ccn-cert.cni.es/amparo/API/public/certificaciones/7841/download/6496";

  swalConfirmButtonAndIconColor = '#294ADB';
  swalWidth = '510px';
  
  version: string = packageJson.version;
  versionInfo = null
  oldVersionInfo = null
  versionsList = [];
  isMobile: boolean;
  fadeInClass = {
    popup: `
      animate__animated
      animate__fadeInDown
      animate__faster
    `
  }
  currentVersion = true;
  loading = true;

  dontShowAgain: boolean = false;
  ultimo_inicio_sesion: string;
  private $destroyRef = inject(DestroyRef);
  
  ngOnInit(): void {
    this._listenDOMChange.isMobile
      .pipe( takeUntilDestroyed(this.$destroyRef) )
      .subscribe( isMobile => this.isMobile = isMobile );
    this.loaderService.isLoading$().subscribe(loading => this.loading = loading);

    this.db.getTerminoEnsUsuario().subscribe((res)=>{
      this.ultimo_inicio_sesion = res[0].ultimo_inicio_sesion;
    });
  }

  getCurrentVersionChanges() {
    this.currentVersion = true;
    this.swalWidth = this.isMobile ? '95vw' : '50vw';
    
    
    this.updateService.getUpdateChanges().subscribe(
      (release) => {
        this.versionInfo = release;
        this.changesSwal.fire();
      }
    )
    
    this.updateService.checkForUpdate();
  }

  lookForUpdates() {
    this.updateService.checkForUpdate();
  }

  clearUpdateMessage() {
    if (!this.currentVersion) {
      this.oldVersionInfo = true;
    } else {
      this.updateService.updateMessageShown();
    }
  }

  copyReleaseNotes() {
    this.clipboard.text = this.versionInfo.body;
    this.clipboard.copy()
    return false;
  }

  updateHistory() {
    this.loaderService.showSpinner();
    this.updateService.getUpdateHistory().subscribe(
      (releases) => {
        this.versionsList = releases;
        this.loaderService.hideSpinner();
        this.versionsListSwal.fire();
      }
    )
  }

  getVersionDetails(tagName) {
    this.currentVersion = false;
    this.loaderService.showSpinner();
    this.db.getLatestRelease(tagName)
    .subscribe((release) => {
      this.oldVersionInfo = release;
      this.loaderService.hideSpinner();
      this.changesSwal.fire();
    })
  }

  /**
   * Confirma los terminos del servicio por parte del usuario
   */
  confirmarTerminos() {
    this.fse.agregarActualizar('terminos', 'true');
    if(this.dontShowAgain) {
      this.db.updateTerminoEnsUsuario(this.dontShowAgain).subscribe(() => {
        location.replace('/traffic');
      })
    }
  }

  /**
   * No volver a mostrar el mensaje de advertencia de terminos ENS
   * @param event event
   */
  onCheckboxChange(event: MatCheckboxChange) {
    this.dontShowAgain = event.checked;
  }
}
